<template>
  <section
    class="flex flex-col md:flex-row items-center justify-center bg-gray-900 p-8 md:p-12 shadow-xl"
  >
    <!-- Profile Picture with 3D hover -->
    <div class="relative group w-full md:w-1/2 flex justify-center mb-10 md:mb-0">
      <div class="profile-wrapper">
        <img
          src="@/assets/profile.jpg"
          alt="Profile"
          class="profile-img"
        />
      </div>
    </div>

    <!-- Introduction Text -->
    <div class="w-full md:w-1/2 text-center md:text-left md:pl-10">
      <h2 class="intro-title">
        👋 Hi, I'm Engr.Lester T. Francisco
      </h2>
      <p class="intro-text">
        Proprietor and the Head developer of PH Web Development Services<br>
        <span class="highlight">Let’s build your website and mobile applications!</span>
      </p>
        <a href="viber://chat?number=09915785155" target="_blank">
            <button class="contact-btn">
                Contact Me
            </button>
        </a>
    </div>
  </section>
</template>

<script>
export default {
  name: "IntroSection",
};
</script>

<style scoped>
/* ===== Image 3D Effect ===== */
.profile-wrapper {
  perspective: 1000px;
}
.profile-img {
  width: 100%;
  max-width: 500px;  /* ✅ Image set to 500x500 max */
  height: auto;
  border-radius: 1.5rem; /* keep rounded edges on the image */
  object-fit: cover;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.6);
  transition: transform 0.6s ease, box-shadow 0.6s ease;
}
.profile-wrapper:hover .profile-img {
  transform: rotateY(15deg) rotateX(5deg) scale(1.05);
  box-shadow: 0 30px 60px rgba(0, 0, 0, 0.8);
}

/* ===== Text Effects ===== */
.intro-title {
  font-size: 2.2rem;
  font-weight: 800;
  color: #f9fafb; /* gray-50 */
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
  overflow: hidden;
}
.intro-title::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  bottom: 0;
  background: linear-gradient(90deg, #3b82f6, #9333ea);
  transform: translateX(-100%);
  animation: slideIn 1.2s forwards;
}
@keyframes slideIn {
  to {
    transform: translateX(0);
  }
}

.intro-text {
  font-size: 1.1rem;
  line-height: 1.75rem;
  color: #d1d5db; /* gray-300 */
  margin-bottom: 1.5rem;
  animation: fadeIn 1.8s ease forwards;
  opacity: 0;
}
@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

.highlight {
  color: #60a5fa; /* blue-400 */
  font-weight: 600;
}

/* ===== Button Styling ===== */
.contact-btn {
  background: linear-gradient(135deg, #3b82f6, #9333ea);
  color: white;
  padding: 0.75rem 2rem;
  border-radius: 0.75rem;
  font-weight: 600;
  box-shadow: 0 8px 20px rgba(59, 130, 246, 0.4);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.contact-btn:hover {
  transform: translateY(-3px) scale(1.03);
  box-shadow: 0 12px 25px rgba(59, 130, 246, 0.5);
}
</style>
